import { render, staticRenderFns } from "./PxCamposRequisicaoProdutosViewSeniorMega.vue?vue&type=template&id=468abdc0&"
import script from "./PxCamposRequisicaoProdutosViewSeniorMega.vue?vue&type=script&lang=js&"
export * from "./PxCamposRequisicaoProdutosViewSeniorMega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
